import { Record, Union } from "../../../fable_modules/fable-library-js.4.24.0/Types.js";
import { Stock, Stock_$reflection } from "../../../Shopfoo.Domain.Types/Warehouse.js";
import { record_type, class_type, union_type, unit_type } from "../../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505, Remote_ofResult, Remote$1, ApiRequestArgs$2, ApiCall$1, Cmder__ofApiRequest_Z503C4AF9, Remote$1_$reflection, ApiCall$1_$reflection } from "../../../Remoting.js";
import { Drawer, DrawerControl__Close_52723E41 } from "../Shared.js";
import { unwrap } from "../../../fable_modules/fable-library-js.4.24.0/Option.js";
import { Result_Map, FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Cmd_ofEffect, Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { FullContext__get_Now } from "../../../Shopfoo.Shared/Remoting.js";
import { Result_tryGetError } from "../../../Shopfoo.Common/Common.js";
import { createElement } from "react";
import React from "react";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { JS_runAfter } from "../../../UI.js";
import { round, createObj } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { TranslationPages_Home__SavedError_Z384F8060, TranslationPages_Product__get_Stock, TranslationPages_Home__SavedOk_Z721C83C5, TranslationPages_Home__get_Save, AppTranslations__get_Home, TranslationPages_Home__get_Close, TranslationPages_Product__get_StockAfterInventory, TranslationPages_Product__get_StockBeforeInventory, AppTranslations__get_Product, TranslationPages_Product__get_StockAction } from "../../../Shopfoo.Shared/Translations.js";
import { singleton as singleton_1, ofArray } from "../../../fable_modules/fable-library-js.4.24.0/List.js";
import { join } from "../../../fable_modules/fable-library-js.4.24.0/String.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { PropHelpers_createOnKey } from "../../../fable_modules/Feliz.2.9.0/Properties.fs.js";
import { key_enter } from "../../../fable_modules/Feliz.2.9.0/Key.fs.js";
import { Buttons_SaveButton_Z19F3502D } from "../../../Components/Buttons.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StockChanged", "AdjustStock"];
    }
}

function Msg_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.Details.AdjustStock.Msg", [], Msg, () => [[["Item", Stock_$reflection()]], [["Item", ApiCall$1_$reflection(unit_type)]]]);
}

class Model extends Record {
    constructor(Stock, SaveDate) {
        super();
        this.Stock = Stock;
        this.SaveDate = SaveDate;
    }
}

function Model_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Details.AdjustStock.Model", [], Model, () => [["Stock", Stock_$reflection()], ["SaveDate", Remote$1_$reflection(class_type("System.DateTime"))]]);
}

function Model__CloseDrawer_150B9DE5(model, drawerControl) {
    DrawerControl__Close_52723E41(drawerControl, unwrap((model.SaveDate.tag === 3) ? (new Drawer(3, [model.Stock])) : undefined));
}

function Cmd_adjustStock(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Prices.AdjustStock(request), (arg_1) => (new Msg(1, [new ApiCall$1(1, [new FSharpResult$2(1, [arg_1])])])), () => (new Msg(1, [new ApiCall$1(1, [new FSharpResult$2(0, [undefined])])]))));
}

function init(stock) {
    return [new Model(stock, new Remote$1(0, [])), Cmd_none()];
}

function update(fullContext, onSave, msg, model) {
    let tupledArg;
    if (msg.tag === 1) {
        if (msg.fields[0].tag === 1) {
            return [new Model(model.Stock, Remote_ofResult(Result_Map(() => FullContext__get_Now(fullContext), msg.fields[0].fields[0]))), Cmd_ofEffect((_arg_1) => {
                onSave([model.Stock, Result_tryGetError(msg.fields[0].fields[0])]);
            })];
        }
        else {
            return [new Model(model.Stock, new Remote$1(1, [])), (tupledArg = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, model.Stock), Cmd_adjustStock(tupledArg[0], tupledArg[1]))];
        }
    }
    else {
        return [new Model(msg.fields[0], model.SaveDate), Cmd_none()];
    }
}

export function AdjustStockForm(adjustStockFormInputProps) {
    let elems_3, elems, elems_1, elems_2;
    const onSave = adjustStockFormInputProps.onSave;
    const drawerControl = adjustStockFormInputProps.drawerControl;
    const stock = adjustStockFormInputProps.stock;
    const fullContext = adjustStockFormInputProps.fullContext;
    const key = adjustStockFormInputProps.$key;
    let patternInput;
    const init_1 = init(stock);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, model) => update(fullContext, onSave, msg, model), (_arg, _arg_1) => {
    }), undefined, []);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    reactApi.useEffect(() => {
        if (model_1.SaveDate.tag === 3) {
            JS_runAfter(500, () => {
                Model__CloseDrawer_150B9DE5(model_1, drawerControl);
            });
        }
    });
    const translations = fullContext.Translations;
    const currentStock = stock.Quantity | 0;
    const newStock = model_1.Stock.Quantity | 0;
    const afterSaveOk = model_1.SaveDate.tag === 3;
    const canSave = (newStock - currentStock) !== 0;
    return createElement("fieldset", createObj(Helpers_combineClasses("fieldset", ofArray([["key", `${key}-fieldset`], (elems_3 = [createElement("legend", {
        key: `${key}-legend`,
        className: "text-base font-bold mb-2 flex items-center",
        children: TranslationPages_Product__get_StockAction(AppTranslations__get_Product(translations)).AdjustStockAfterInventory,
    }), createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", `${key}-current-stock-fieldset-label`], ["children", TranslationPages_Product__get_StockBeforeInventory(AppTranslations__get_Product(translations))]])))), createElement("label", createObj(Helpers_combineClasses("input", ofArray([["key", `${key}-current-stock-label`], ["className", "bg-base-300 w-full mb-2"], (elems = [createElement("input", {
        key: `${key}-current-stock-input`,
        "aria-readonly": true,
        readOnly: true,
        value: currentStock,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", `${key}-new-stock-fieldset-label`], ["children", TranslationPages_Product__get_StockAfterInventory(AppTranslations__get_Product(translations))]])))), createElement("label", createObj(Helpers_combineClasses("input", ofArray([["key", `${key}-new-stock-label`], ["className", join(" ", toList(delay(() => append(singleton("w-full mb-4"), delay(() => (afterSaveOk ? singleton("bg-base-300") : empty()))))))], (elems_1 = [createElement("input", createObj(toList(delay(() => append(singleton(["key", `${key}-new-stock-input`]), delay(() => append(singleton(["type", "number"]), delay(() => append(singleton(["className", "flex-1 validator"]), delay(() => append(singleton(["required", true]), delay(() => append(singleton(["value", newStock]), delay(() => append(afterSaveOk ? append(singleton(["aria-readonly", true]), delay(() => singleton(["readOnly", true]))) : append(singleton(["onChange", (ev) => {
        const value_47 = ev.target.valueAsNumber;
        if (!(value_47 == null) && !Number.isNaN(value_47)) {
            dispatch(new Msg(0, [new Stock(model_1.Stock.SKU, round(value_47))]));
        }
    }]), delay(() => (canSave ? singleton(["onKeyUp", (ev_1) => {
        PropHelpers_createOnKey(key_enter, (_arg_2) => {
            dispatch(new Msg(1, [new ApiCall$1(0, [])]));
        }, ev_1);
    }]) : empty()))), delay(() => append(singleton(["min", 0]), delay(() => singleton(["step", 1])))))))))))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), createElement("div", createObj(ofArray([["key", `${key}-save-div`], ["className", "flex justify-end"], (elems_2 = [createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-secondary"], ["className", "btn-outline"], ["key", `${key}-close-button`], ["className", "mr-2"], ["onClick", (_arg_3) => {
        Model__CloseDrawer_150B9DE5(model_1, drawerControl);
    }], ["children", TranslationPages_Home__get_Close(AppTranslations__get_Home(translations))]])))), createElement(Buttons_SaveButton_Z19F3502D, {
        key: "save-price",
        $key: "save-price",
        label: TranslationPages_Home__get_Save(AppTranslations__get_Home(translations)),
        tooltipOk: TranslationPages_Home__SavedOk_Z721C83C5(AppTranslations__get_Home(translations), TranslationPages_Product__get_Stock(AppTranslations__get_Product(translations))),
        tooltipError: (err) => TranslationPages_Home__SavedError_Z384F8060(AppTranslations__get_Home(translations), TranslationPages_Product__get_Stock(AppTranslations__get_Product(translations)), err.ErrorMessage),
        tooltipProps: singleton_1(["className", "tooltip-left"]),
        saveDate: model_1.SaveDate,
        disabled: afterSaveOk ? true : !canSave,
        onClick: () => {
            dispatch(new Msg(1, [new ApiCall$1(0, [])]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
}

